export default __webpack_public_path__ + "static/char-10-26cd2986ebbeec24d10120f263eab1c7.webp";